import React from 'react';
import { useStore } from 'effector-react';
import { ImageType, type STImage, type STMatrix } from '@types';
import Image from '@components/Image';
import { $curSandTable } from '@stores/dataStores';
import Button from '@components/Button';
import { $GateCompassSetting, showCompassSetting } from './CompassSetting';

export function CompassWidget() {
  const isSetting = useStore($GateCompassSetting.state);
  const { angle, id } = useStore($curSandTable) as STImage | STMatrix;

  if (isSetting) return null;
  return (
    <div className="absolute top-20 left-20 flex select-none flex-col items-center">
      <Image
        src="/imgs/compass-w.6e900f2986943c8441bb3ca60efa7384.png"
        draggable={false}
        type={ImageType.sysMedia}
        style={{ width: 100, height: 100, transform: `rotate(${angle}deg)` }}
      />
      <Button
        className="mt-10 select-auto"
        onClick={() => {
          showCompassSetting({ sandTableId: id, angle });
        }}
      >
        设置指北针
      </Button>
    </div>
  );
}
